import React, { Component } from "react";
import "../style/proofInfo.scss";
import HeadBar from "./common/HeadBar";
import idCard from "../image/ID-card.png";
import cardBack from "../image/document_back.png";
import { Radio } from "antd";
import * as UploadAPI from "../apis/UploadAPI";
import Loading from "./common/Loading";
import BWM from "../icon/Bmw";
import { BASE_URL } from "../constants/ApiEndpointConstants";
import * as FacebookAPI from "../apis/FacebookAPI";
import * as UpdateOrderAPI from "../apis/UpdateOrderAPI";
import { routePage } from "../utils/routePage";
import MarkIcon from "../icon/MarkIcon";
import cardMask from "../image/card-mask.jpg";
import Close from "../icon/Close";
import proofBackground from "../image/proof-background.jpg";
import proof from "../image/proof-of-address.jpg";
import Tip from "../icon/Tip";
import Warning from "../icon/Warning";
import CheckBox from "../icon/CheckBox";
import safeParse from "../utils/SafeParseLocalstrorage";
import { lang } from "../utils/lang";
import getAd from "../utils/GetAd";

class ProofInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingShow: false,
      cardList: [
        { title: "Bank Statement", checked: true },
        { title: "Gas Utility Bill", checked: false },
        { title: "Electricity or Water Utility Bill", checked: false },
        { title: "Telephone or Landline Bill", checked: false },
      ],
      addressProofDocument: "",
      proofAdressType: "Bank Statement",
      orderDetail: safeParse("orderDetail") || {},
      ad: getAd(),
      showCardMask: false,
      isFirstSubmitProof: safeParse("isFirstSubmitProof" || 0),
      smooth: true,
    };
    this.changeChecked = this.changeChecked.bind(this);
    this.upload = this.upload.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
    this.routeSelfie = this.routeSelfie.bind(this);
    this.showCardMask = this.showCardMask.bind(this);
  }

  componentDidMount() {
    let { orderDetail, cardList } = this.state;
    if (orderDetail?.proofAdressType) {
      this.setState({
        proofAdressType: orderDetail?.proofAdressType || "Bank Statement",
        addressProofDocument: orderDetail?.addressProofDocument || "",
        cardList: cardList.map((item) => ({
          ...item,
          checked: item.title === orderDetail?.proofAdressType,
        })),
      });
    }
    const timer = setTimeout(() => {
      clearTimeout(timer);
      this.setState({ smooth: false });
    }, 100);
  }

  changeChecked(index) {
    let { cardList } = this.state;
    cardList.map((item, itemIndex) => {
      item.checked = false;
      if (index === itemIndex) {
        item.checked = true;
        this.setState({ proofAdressType: item.title });
      }
    });
    this.setState({ cardList });
  }

  upload(e, type) {
    let { orderDetail, ad } = this.state;
    var _that = this;
    console.log(e.target.files[0]);

    [e.target.files[0]].forEach((fileItem, fileIndex) => {
      if (fileIndex > 0) return;
      let reads = new FileReader();
      reads?.readAsDataURL(fileItem);
      reads.onload = function (e) {
        const imgUrl = this.result;
        _that.toggleShow();

        UploadAPI.upload(imgUrl, orderDetail?.snCode).then((res) => {
          var url = res.data.data.url;
          switch (type) {
            case "proof":
              _that.setState({ addressProofDocument: url }, () => {
                orderDetail.addressProofDocument = url;
                UpdateOrderAPI.updateOrderInformation(orderDetail)
                  .then((res) => {
                    _that.toggleShow();
                  })
                  .catch((err) => {
                    _that.toggleShow();
                  });
              });
              break;
            default:
              break;
          }
        });
      };
    });
    e.target.value = ""; //清空input的值，让同一张图片下一次也能触发onChange
  }

  toggleShow() {
    this.setState({ loadingShow: !this.state.loadingShow });
  }

  routeSelfie() {
    let { location, history } = this.props;
    let {
      proofAdressType,
      addressProofDocument,
      isFirstSubmitProof,
      orderDetail,
      ad,
    } = this.state;
    if (isFirstSubmitProof < 1) {
      localStorage.setItem("isFirstSubmitProof", 1);
      return this.setState({
        showCardMask: !this.state.showCardMask,
        isFirstSubmitProof: 1,
        addressProofDocument: "",
      });
    }
    routePage(history, ad, "/information");
    orderDetail.addressProofDocument = addressProofDocument;
    orderDetail.proofAdressType = proofAdressType;
    localStorage.setItem("orderDetail", JSON.stringify(orderDetail));
  }

  showCardMask() {
    this.setState({ showCardMask: !this.state.showCardMask });
  }

  render() {
    const { cardList, addressProofDocument, showCardMask } = this.state;
    let nextBtn = false;

    nextBtn = addressProofDocument !== "";

    return (
      <React.Fragment>
        {showCardMask && (
          <div className="proof-mask">
            <div className="card-box" onClick={this.showCardMask}>
              <Close size={24} color="#424242" className="close-Icon" />

              <div className="img">
                <img src={proof} alt="Address Verification Document" />
              </div>

              <div className="title">Address Verification Failed</div>

              <div className="li-box">
                <li>
                  <Tip size={16} color="red" />
                  <p>Screenshots are not accepted.</p>
                </li>
                <li>
                  <Tip size={16} color="red" />
                  <p>Ensure that no edges of the document are obscured.</p>
                </li>
                <li>
                  <CheckBox size={16} color="green" />
                  <p>
                    Ensure the document was issued within the last{" "}
                    <span>180</span> days.
                  </p>
                </li>
                <li>
                  <CheckBox size={16} color="green" />
                  <p>
                    Make sure all text on the document is clear and legible.
                  </p>
                </li>
                <li>
                  <Warning size={16} color="red" />
                  <p>
                    <span>
                      Submitting the file in PDF format is recommended.
                    </span>
                  </p>
                </li>
              </div>
            </div>
          </div>
        )}
        <Loading {...this.props} loadingShow={this.state.loadingShow} />
        <div className="proofInfo-page">
          <HeadBar {...this.props} />
          <div className={`info-box ${this.state.smooth ? "smooth" : ""}`}>
            <h1>Choose a document to verify your address</h1>
            <p className="p">
              To verify your address, please upload a document issued within the
              last 6 months that clearly shows your current residential address.
              PDF format is recommended.
            </p>
            {cardList.map((item, index) => {
              return (
                <div
                  className="input-row"
                  key={index}
                  onClick={() => this.changeChecked(index)}
                >
                  <Radio checked={item.checked}></Radio> {"  "}{" "}
                  <p>{item.title}</p>
                </div>
              );
            })}
            <div className="id-card">
              <div className="col-box">
                {addressProofDocument === "" ? (
                  <React.Fragment>
                    <img src={proofBackground} alt="" />
                    <div className="tip-txt">
                      Hochladen des Adressnachweises
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <iframe
                      src={`${
                        BASE_URL + addressProofDocument
                      }#toolbar=0&navpanes=0&scrollbar=0`}
                      alt=""
                      width="100%"
                      height="300px"
                      style={{ border: "none", overflow: "scroll" }}
                    ></iframe>
                  </React.Fragment>
                )}
                <input
                  type="file"
                  className="file-box"
                  accept="application/pdf"
                  onChange={(e) => this.upload(e, "proof")}
                />
              </div>
            </div>
            <div
              className={nextBtn ? "check" : "btn"}
              onClick={nextBtn ? this.routeSelfie : undefined}
            >
              {lang.next}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ProofInfo;
